import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

declare var google: any;

@Injectable()
export class GoogleMapsHelperService {

    private mexicoBoundaryCoords = [
        {lat: 32.715736, lng: -117.202338},
        {lat: 32.599208, lng: -116.938666},
        {lat: 32.522264, lng: -116.323431},
        {lat: 32.484229, lng: -115.928823},
        {lat: 32.484229, lng: -115.664151},
        {lat: 32.406823, lng: -115.268643},
        {lat: 32.251882, lng: -114.829287},
        {lat: 32.173991, lng: -114.785342},
        {lat: 32.056807, lng: -114.697451},
        {lat: 31.784663, lng: -114.433779},
        {lat: 31.706085, lng: -114.697451},
        {lat: 31.588577, lng: -114.960850},
        {lat: 31.471040, lng: -115.356085},
        {lat: 31.392428, lng: -115.619757},
        {lat: 31.314158, lng: -115.883429},
        {lat: 31.471040, lng: -116.499209},
        {lat: 31.744103, lng: -116.806826},
        {lat: 31.941479, lng: -117.114444},
        {lat: 32.175469, lng: -117.290225},
        {lat: 29.089090, lng: -113.291146},
        {lat: 27.891963, lng: -111.621390},
        {lat: 27.662777, lng: -110.039575},
        {lat: 27.430815, lng: -109.072779},
        {lat: 27.777004, lng: -108.501489},
        {lat: 27.969068, lng: -108.237817},
        {lat: 28.467924, lng: -108.193872},
        {lat: 28.692069, lng: -108.281763},
        {lat: 28.917126, lng: -108.325708},
        {lat: 29.141269, lng: -108.501489},
        {lat: 29.257801, lng: -108.765161},
        {lat: 29.374320, lng: -109.028833},
        {lat: 29.608189, lng: -109.424341},
        {lat: 29.842006, lng: -109.863694},
        {lat: 30.534669, lng: -110.698655},
        {lat: 30.767585, lng: -111.181780},
        {lat: 31.000444, lng: -111.621133},
        {lat: 31.388695, lng: -112.104258},
        {lat: 31.582085, lng: -112.323985},
        {lat: 31.853932, lng: -112.631602},
        {lat: 32.009170, lng: -113.114727},
        {lat: 32.203884, lng: -113.378399},
        {lat: 32.476040, lng: -113.510235},
        {lat: 32.516168, lng: -113.642071},
        {lat: 31.972638, lng: -113.598125},
        {lat: 31.586298, lng: -113.202618},
        {lat: 31.393088, lng: -112.675274},
        {lat: 31.279343, lng: -112.499493},
        {lat: 30.996223, lng: -112.103985},
        {lat: 30.714077, lng: -111.796368},
        {lat: 30.508940, lng: -111.620587},
        {lat: 30.304693, lng: -111.400860},
        {lat: 30.139687, lng: -111.225079},
        {lat: 29.737239, lng: -110.873517},
        {lat: 29.491772, lng: -110.610009},
        {lat: 29.167169, lng: -110.390282},
        {lat: 28.880877, lng: -110.302392},
        {lat: 28.438596, lng: -109.951002},
        {lat: 27.995409, lng: -109.599439},
        {lat: 27.670088, lng: -109.291821},
        {lat: 27.422947, lng: -109.159986},
        {lat: 26.931978, lng: -109.160258},
        {lat: 26.480082, lng: -109.424341},
        {lat: 26.439922, lng: -109.907193},
        {lat: 26.400666, lng: -110.390282},
        {lat: 26.361402, lng: -110.697899},
        {lat: 26.400666, lng: -111.269189},
        {lat: 26.361402, lng: -111.972314},
        {lat: 26.203756, lng: -112.587549},
        {lat: 26.046998, lng: -113.026902},
        {lat: 25.889332, lng: -113.290574},
        {lat: 25.652509, lng: -113.598192},
        {lat: 25.336518, lng: -113.993699},
        {lat: 24.863047, lng: -114.609479},
        {lat: 24.743033, lng: -114.785260},
        {lat: 24.547234, lng: -114.961041},
        {lat: 24.391394, lng: -115.048932},
        {lat: 24.115699, lng: -115.356549},
        {lat: 23.998948, lng: -115.312604},
        {lat: 23.842115, lng: -115.048932},
        {lat: 23.488001, lng: -114.697370},
        {lat: 23.211863, lng: -114.389752},
        {lat: 22.777039, lng: -113.906627},
        {lat: 22.656854, lng: -113.554793},
        {lat: 22.064440, lng: -112.939831},
        {lat: 21.748044, lng: -112.544323},
        {lat: 21.826866, lng: -112.192761},
        {lat: 21.904796, lng: -111.841199},
        {lat: 22.102447, lng: -111.621472},
        {lat: 22.578306, lng: -111.401745},
        {lat: 23.174009, lng: -110.654675},
        {lat: 23.449784, lng: -110.258968},
        {lat: 23.842115, lng: -109.995296},
        {lat: 24.274354, lng: -109.863461},
        {lat: 24.313581, lng: -109.291621},
        {lat: 24.235429, lng: -108.764277},
        {lat: 24.003985, lng: -108.368770},
        {lat: 23.695376, lng: -108.016934},
        {lat: 23.502499, lng: -107.709317},
        {lat: 23.541693, lng: -107.313809},
        {lat: 23.852502, lng: -106.918302},
        {lat: 24.352489, lng: -106.698575},
        {lat: 24.657963, lng: -106.523067},
        {lat: 24.891593, lng: -106.215450},
        {lat: 25.124315, lng: -105.952050},
        {lat: 25.472730, lng: -105.644160},
        {lat: 25.821040, lng: -105.424433},
        {lat: 26.208532, lng: -105.248652},
        {lat: 26.635848, lng: -105.116816},
        {lat: 26.948460, lng: -104.941035},
        {lat: 27.377135, lng: -104.677363},
        {lat: 27.726523, lng: -104.237737},
        {lat: 28.117022, lng: -103.886175},
        {lat: 28.624055, lng: -103.666448},
        {lat: 29.052010, lng: -103.402776},
        {lat: 29.402801, lng: -103.182776},
        {lat: 29.869170, lng: -102.963322},
        {lat: 30.605906, lng: -102.919376},
        {lat: 31.066458, lng: -102.875431},
        {lat: 31.413766, lng: -102.699650},
        {lat: 31.762075, lng: -102.567814},
        {lat: 31.994873, lng: -102.435978},
        {lat: 32.228649, lng: -102.304143},
        {lat: 32.345455, lng: -102.128362},
        {lat: 32.501401, lng: -101.908635},
        {lat: 31.996353, lng: -101.733126},
        {lat: 31.606822, lng: -101.557345},
        {lat: 31.411676, lng: -101.425509},
        {lat: 31.255673, lng: -101.249728},
        {lat: 31.060477, lng: -101.161838},
        {lat: 30.826675, lng: -101.029729},
        {lat: 30.631472, lng: -100.941839},
        {lat: 30.281020, lng: -100.809731},
        {lat: 29.969688, lng: -100.722113},
        {lat: 29.774490, lng: -100.678168},
        {lat: 29.462269, lng: -100.546332},
        {lat: 29.228475, lng: -100.502387},
        {lat: 28.994675, lng: -100.502387},
        {lat: 28.683353, lng: -100.502387},
        {lat: 28.332885, lng: -100.458442},
        {lat: 28.021557, lng: -100.414496},
        {lat: 27.709334, lng: -100.282661},
        {lat: 27.475530, lng: -100.282661},
        {lat: 27.319490, lng: -100.370551},
        {lat: 27.163447, lng: -100.722113},
        {lat: 27.007399, lng: -100.722113},
        {lat: 26.695062, lng: -100.854222},
        {lat: 26.539005, lng: -100.898167},
        {lat: 26.421080, lng: -101.074221},
        {lat: 26.226843, lng: -101.206057},
        {lat: 26.031707, lng: -101.337893},
        {lat: 25.914668, lng: -101.557620},
        {lat: 25.836756, lng: -101.821292},
        {lat: 25.759732, lng: -102.040746},
        {lat: 25.759732, lng: -102.348364},
        {lat: 25.798839, lng: -102.612036},
        {lat: 25.876733, lng: -102.963598},
        {lat: 25.954625, lng: -103.359106},
        {lat: 26.070760, lng: -103.754613},
        {lat: 26.266891, lng: -104.193966},
        {lat: 26.501157, lng: -104.589474},
        {lat: 26.657213, lng: -104.897091},
        {lat: 26.735137, lng: -105.292599},
        {lat: 26.814056, lng: -105.512326},
        {lat: 26.813076, lng: -105.907834},
        {lat: 26.931978, lng: -106.346914},
        {lat: 27.128127, lng: -106.830312},
        {lat: 27.246037, lng: -107.401602},
        {lat: 27.597404, lng: -108.016655},
        {lat: 27.829829, lng: -108.456281},
        {lat: 28.218039, lng: -108.983625},
        {lat: 28.606228, lng: -109.511524},
        {lat: 28.956310, lng: -109.907304},
        {lat: 29.267270, lng: -110.302812},
        {lat: 29.617336, lng: -110.698593},
        {lat: 29.968291, lng: -111.182163},
        {lat: 30.472219, lng: -111.973743},
        {lat: 30.937978, lng: -112.633194},
        {lat: 31.251944, lng: -113.204484},
        {lat: 31.565889, lng: -113.687882},
        {lat: 28.975180, lng: -113.247256},
        {lat: 28.227865, lng: -112.104258},
        {lat: 27.363064, lng: -110.786318},
        {lat: 26.615212, lng: -109.643593},
        {lat: 25.982037, lng: -108.632578},
        {lat: 25.463551, lng: -107.841271},
        {lat: 24.907792, lng: -107.137873},
        {lat: 24.611542, lng: -106.610529},
        {lat: 24.613512, lng: -106.258967},
        {lat: 24.613512, lng: -105.863459},
        {lat: 24.493415, lng: -105.468224},
        {lat: 24.254471, lng: -105.204552},
        {lat: 23.935989, lng: -104.941152},
        {lat: 23.618399, lng: -104.765371},
        {lat: 23.301695, lng: -104.545644},
        {lat: 23.141968, lng: -104.501972},
        {lat: 22.944105, lng: -104.633535},
        {lat: 22.823330, lng: -105.028770},
        {lat: 22.665210, lng: -105.380060},
        {lat: 22.508001, lng: -105.687677},
        {lat: 22.311723, lng: -106.039512},
        {lat: 22.076338, lng: -106.391347},
        {lat: 21.882045, lng: -106.655019},
        {lat: 21.648638, lng: -107.050527},
        {lat: 21.454322, lng: -107.226308},
        {lat: 21.415117, lng: -107.665934},
        {lat: 21.298835, lng: -107.929606},
        {lat: 21.142479, lng: -108.061442},
        {lat: 20.948137, lng: -108.237223},
        {lat: 20.796110, lng: -108.632731},
        {lat: 20.767813, lng: -86.928557},
        {lat: 20.521072, lng: -87.236174},
        {lat: 20.232705, lng: -87.411956},
        {lat: 19.943803, lng: -87.543792},
        {lat: 19.281475, lng: -87.719573},
        {lat: 19.156987, lng: -87.587737},
        {lat: 18.658099, lng: -87.675628},
        {lat: 18.449793, lng: -87.763518},
        {lat: 18.157740, lng: -87.939299},
        {lat: 17.823367, lng: -88.071135},
        {lat: 18.533146, lng: -88.246917},
        {lat: 18.533146, lng: -88.422698},
        {lat: 18.032425, lng: -88.818206},
        {lat: 17.907020, lng: -89.213713},
        {lat: 17.781526, lng: -91.059417},
        {lat: 17.488366, lng: -91.015471},
        {lat: 17.278675, lng: -91.059417},
        {lat: 17.236708, lng: -91.454924},
        {lat: 16.479692, lng: -90.444182},
        {lat: 16.226688, lng: -90.488128},
        {lat: 16.100063, lng: -90.488128},
        {lat: 16.101685, lng: -91.757998},
        {lat: 15.340265, lng: -92.153506},
        {lat: 14.873574, lng: -92.549013},
        {lat: 16.101685, lng: -93.999209},
        {lat: 16.397013, lng: -94.878115},
        {lat: 15.721331, lng: -96.284365},
        {lat: 15.932728, lng: -97.558779},
        {lat: 16.776063, lng: -99.931826},
        {lat: 17.615673, lng: -101.601748},
        {lat: 18.326290, lng: -103.491396},
        {lat: 19.780065, lng: -105.337099},
        {lat: 20.563804, lng: -105.644717},
        {lat: 22.485075, lng: -105.776552},
        {lat: 24.699853, lng: -108.061709},
        {lat: 26.049799, lng: -109.555849},
        {lat: 26.365221, lng: -109.467959},
        {lat: 26.679784, lng: -109.467959},
        {lat: 26.797522, lng: -109.863467},
        {lat: 28.780105, lng: -111.972842},
        {lat: 30.650128, lng: -113.159365},
        {lat: 31.140353, lng: -113.115420},
        {lat: 31.365762, lng: -113.510927},
        {lat: 31.478264, lng: -113.862490},
        {lat: 31.553190, lng: -114.433779},
        {lat: 31.702863, lng: -114.653506},
        {lat: 31.628057, lng: -114.829287},
        {lat: 30.119401, lng: -114.521670},
        {lat: 29.394547, lng: -113.906435},
        {lat: 28.741581, lng: -113.203310},
        {lat: 28.006938, lng: -112.807802},
        {lat: 27.267251, lng: -112.236513},
        {lat: 26.719043, lng: -111.665224},
        {lat: 26.010311, lng: -111.313662},
        {lat: 25.416410, lng: -111.049990},
        {lat: 24.659922, lng: -110.786318},
        {lat: 24.299969, lng: -110.566592},
        {lat: 24.340014, lng: -110.215029},
        {lat: 24.099551, lng: -109.995302},
        {lat: 23.697777, lng: -109.511904},
        {lat: 23.294761, lng: -109.424013},
        {lat: 22.890522, lng: -109.687685},
        {lat: 22.931000, lng: -110.083193},
        {lat: 23.496423, lng: -110.302920},
        {lat: 24.259910, lng: -111.401552},
        {lat: 24.979012, lng: -111.972842},
        {lat: 25.535427, lng: -112.148623},
        {lat: 26.443942, lng: -112.807802},
        {lat: 26.836741, lng: -113.774599},
        {lat: 27.384376, lng: -114.609560},
        {lat: 27.773894, lng: -115.049013},
        {lat: 27.929313, lng: -114.477724},
        {lat: 28.200758, lng: -114.301943},
        {lat: 28.471515, lng: -114.257998},
        {lat: 28.818615, lng: -114.433779},
        {lat: 29.317942, lng: -114.961123},
        {lat: 29.791819, lng: -115.664248},
        {lat: 30.286372, lng: -115.927920},
        {lat: 30.816193, lng: -116.103701},
        {lat: 31.268013, lng: -116.499209},
        {lat: 32.647495, lng: -117.246279}
    ];

    /**
     * Validates if a point (LatLng) is within Mexico's boundaries
     */
    public isPointInMexico(lat: number, lng: number): boolean {
        const polygon = new google.maps.Polygon({
            paths: this.mexicoBoundaryCoords
        });
        const point = new google.maps.LatLng(lat, lng);
        return google.maps.geometry.poly.containsLocation(point, polygon);
    }

    /**
     * Validates if a geocoding result is in Mexico by checking address_components
     * This is more reliable than polygon boundaries
     */
    public isGeocodingResultInMexico(geocodeResult: any): boolean {
        if (!geocodeResult || !geocodeResult.address_components) {
            return false;
        }

        const countryComponent = geocodeResult.address_components.find(
            function(component) {
                return component.types.indexOf('country') !== -1;
            }
        );

        return countryComponent && countryComponent.short_name === 'MX';
    }

    /**
     * Validates origin and destination are within Mexico using geocoding results
     * This is more reliable than polygon boundaries
     */
    public validateGeocodingResultsInMexico(origenResult: any, destinoResult: any): {
        origenEnMexico: boolean;
        destinoEnMexico: boolean;
        errorMessage: string;
    } {
        const origenEnMexico = this.isGeocodingResultInMexico(origenResult);
        const destinoEnMexico = this.isGeocodingResultInMexico(destinoResult);

        let errorMessage = '';

        if (!origenEnMexico) {
            errorMessage = 'La dirección de ORIGEN esta fuera de México, intenta con una más específica';
        }
        if (!destinoEnMexico) {
            if (errorMessage) {
                errorMessage += ' y la dirección de DESTINO esta fuera de México';
            } else {
                errorMessage = 'La dirección de DESTINO esta fuera de México, intenta con una más específica';
            }
        }

        return {
            origenEnMexico: origenEnMexico,
            destinoEnMexico: destinoEnMexico,
            errorMessage: errorMessage
        };
    }

    /**
     * Validates origin and destination are within Mexico
     * Returns an object with validation results and error messages
     */
    public validateLocationsInMexico(origenLat: number, origenLng: number,
                                     destinoLat: number, destinoLng: number): {
        origenEnMexico: boolean;
        destinoEnMexico: boolean;
        errorMessage: string;
    } {
        const origenEnMexico = this.isPointInMexico(origenLat, origenLng);
        const destinoEnMexico = this.isPointInMexico(destinoLat, destinoLng);

        let errorMessage = '';

        if (!origenEnMexico) {
            errorMessage = 'La dirección de ORIGEN esta fuera de México, intenta con una más específica';
        }
        if (!destinoEnMexico) {
            if (errorMessage) {
                errorMessage += ' y la dirección de DESTINO esta fuera de México';
            } else {
                errorMessage = 'La dirección de DESTINO esta fuera de México, intenta con una más específica';
            }
        }

        return {
            origenEnMexico: origenEnMexico,
            destinoEnMexico: destinoEnMexico,
            errorMessage: errorMessage
        };
    }

    /**
     * Calculate the closest origin point from an array of origin points
     * Uses Euclidean distance calculation
     */
    public findClosestOriginPoint(targetLat: number, targetLng: number, 
                                   originPoints: Array<{latitud: number, longitud: number, id_punto_origen: string}>): {
        closest: any;
        index: number;
    } {
        const distance = (p, po) => {
            return Math.sqrt(Math.pow(po.x - p.x, 2) + Math.pow(po.y - p.y, 2));
        };

        const arr_coordinates_puntos_origen = originPoints.map((value, index) => ({
            x: value.latitud / 1,
            y: value.longitud / 1,
            ind: index,
            id: value.id_punto_origen
        }));

        const pointOrigen = {
            x: targetLat,
            y: targetLng
        };

        const closest = arr_coordinates_puntos_origen.reduce((a, b) => 
            distance(a, pointOrigen) < distance(b, pointOrigen) ? a : b
        );

        return {
            closest: closest,
            index: closest.ind
        };
    }

    /**
     * Calculate route between two points using Google Maps DirectionsService
     * Returns a Promise with the route response
     */
    public calculateRoute(origin: {lat: number, lng: number}, 
                         destination: {lat: number, lng: number}, 
                         waypoints?: any[]): Promise<any> {
        return new Promise((resolve, reject) => {
            const directionsService = new google.maps.DirectionsService();
            const lat_lng_origen = new google.maps.LatLng(origin.lat, origin.lng);
            const lat_lng_destino = new google.maps.LatLng(destination.lat, destination.lng);

            const request: any = {
                origin: lat_lng_origen,
                destination: lat_lng_destino,
                travelMode: 'DRIVING'
            };

            if (waypoints && waypoints.length > 0) {
                request.waypoints = waypoints;
            }

            directionsService.route(request, (response, status) => {
                if (status === 'OK') {
                    resolve(response);
                } else {
                    reject(status);
                }
            });
        });
    }

    /**
     * Extract distance information from Google Maps route response
     */
    public extractDistanceFromRoute(routeResponse: any): {
        distanceValue: number;
        distanceText: string;
        durationValue: number;
        durationText: string;
    } {
        if (!routeResponse || !routeResponse.routes || routeResponse.routes.length === 0) {
            return {
                distanceValue: 0,
                distanceText: '0 km',
                durationValue: 0,
                durationText: '0 mins'
            };
        }

        const leg = routeResponse.routes[0].legs[0];
        return {
            distanceValue: leg.distance.value,
            distanceText: leg.distance.text,
            durationValue: leg.duration.value,
            durationText: leg.duration.text
        };
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/integration/google-maps/google-maps-helper.service.ts